import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { RoleService } from 'src/app/service/auth/role.service';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styles: []
})
export class RoleComponent implements OnInit {
    constructor(
        private roleService: RoleService,
        private toastr: ToastrService,
    ) { }

    newItem: any = {};
    roles: any[] = [];
    rolesBackup: any[] = [];

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.roleService.getListRole().subscribe(
            res => {
                this.roles = <any>res;

                this.rolesBackup = JSON.parse(JSON.stringify(this.roles));
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onEdit(id) {
        var r = this.roles.find(x => x.id == id);
        if (r)
            r.isEdit = true;
    }

    onRemove(id) {
        document.getElementById('page-loader-data').style.display = "block";
        this.roleService.deleteRole(id).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.loadData();
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onSave(r) {
        if (r) {
            document.getElementById('page-loader-data').style.display = "block";
            this.roleService.updateRole(r).subscribe(
                res => {
                    this.toastr.success("Thành công");
                    this.loadData();
                    document.getElementById('page-loader-data').style.display = "none";
                },
                err => {
                    this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                    document.getElementById('page-loader-data').style.display = "none";
                },
            );
        }
    }

    onCancel(id) {
        let r = this.roles.find(x => x.id == id);
        let rBk = this.rolesBackup.find(x => x.id == id);
        if (r && rBk) {
            this.roles[this.roles.indexOf(r)] = JSON.parse(JSON.stringify(rBk));
        }
    }

    onCreate() {
        document.getElementById('page-loader-data').style.display = "block";
        this.roleService.createRole(this.newItem).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.loadData();
                this.newItem = {};
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }
}